import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { SharedModule } from '@ddt-web/common';
import { DomService } from '@ddt-web/dom';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { PartnerQueryParamKey } from '@ddt-web/url';

import { InputBoxComponent } from '../input-box/input-box.component';
import { PartnerDebugInfoComponent } from './partner-debug-info.component';

@NgModule({
	declarations: [PartnerDebugInfoComponent, InputBoxComponent],
	imports: [
		CommonModule,
		SharedModule,
		DzButtonModule
	],
	exports: [PartnerDebugInfoComponent]
})
export class PartnerDebugInfoModule {
	constructor(private domService: DomService) {
		const parsedUrl = new URL(window.location.href);
		const showPartnerDebugMode =
			parsedUrl.searchParams.get(PartnerQueryParamKey.PARTNER) ||
			localStorage.getItem(LocalStorageKey.SsoInitiatedFrom) ||
			parsedUrl.searchParams.get(PartnerQueryParamKey.MOCK_PARTNER_API) ||
			localStorage.getItem(PartnerQueryParamKey.MOCK_PARTNER_API);

		if (showPartnerDebugMode) {
			this.domService.prependComponentToBody(PartnerDebugInfoComponent);
		}
	}
}
